import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import PdIcon from '../components/icons/PdIcon.vue'
import D3Icon from '../components/icons/D3Icon.vue'
import VuforiaIcon from '../components/icons/VuforiaIcon.vue'
import ArCoreIcon from '../components/icons/ArCoreIcon.vue'
import BelaIcon from '../components/icons/BelaIcon.vue'
import ArduinoIcon from '../components/icons/ArduinoIcon.vue'
import ReduxIcon from '../components/icons/ReduxIcon.vue'
import PhaserIcon from '../components/icons/PhaserIcon.vue'

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
    themes: {
			light: {
				background: "#F7FAFC",
				primary: "#F6AD55",
				secondary: "#1A202C",
				accent: "#c79105",
				error:"#f44336",
				warning:"#ff5722",
				info: "#FEEBC8",
        success: "#8bc34a",
        text:"#1A202C",
        textLight:"#718096",
        border: "#CBD5E0",
        techIcon: "#4A5568",
        techBackground: "#E2E8F0"
				}
    },
	},
	icons:{
		values: {
      puredata: {
        component: PdIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'puredata',
        },
      },
      d3: {
        component: D3Icon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'd3',
        },
			},
			arcore: {
        component: ArCoreIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'arcore',
        },
			},
			vuforia: {
        component: VuforiaIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'vuforia',
        },
			},
			bela: {
        component: BelaIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'bela',
        },
			},
			arduino: {
        component: ArduinoIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'arduino',
        },
			},
			redux: {
        component: ReduxIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'redux',
        },
      },
      phaser: {
        component: PhaserIcon, // you can use string here if component is registered globally
        props: { // pass props to your component if needed
          name: 'phaser',
        },
      },
    },
	}
});
